<div class="modal-header">
    <h5 class="modal-title text-center ml-auto mr-auto">{{ title | translate: lang }}</h5>
    <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
    </button>
</div>
<div class="modal-body">
  <div class="elems">
    <div class="elem" *ngIf="!lps || !lps.length">
      <p class="text-mon mt-2 text-center">Please select your server first!</p>
    </div>
    <div class="elem" *ngFor="let lp of lps" (click)="onSelect(lp.minLp)">
      <p class="text-mon mt-2 text-center">{{lp.minLp}}-{{lp.maxLp}}</p>
    </div>
    <div class="elem" (click)="onSelect(100)" *ngIf="!disablePromos">
      <p class="text-mon mt-2 text-center modal-switcher">100</p>
    </div>
  </div>
</div>